<template>
  <div class="change-password-container flex-layout" id="change_pwd_container">
    <div class="flex-item left">
      <el-card class="box-card" id="change_password_section">
        <template #header>
          <div class="f16 bold">{{ $sakura.locale.changePassword.title }}</div>
        </template>
        <div class="box-body">
          <el-form
            :model="formData"
            :rules="rules"
            ref="ruleForm"
            label-width="100px"
            label-position="top"
            status-icon
            class="login-card-form"
            id="change_password"
          >
            <el-form-item prop="newPassword" class="mb40">
              <material-input :label="$sakura.locale.changePassword.new_password" size="medium">
                <el-input
                  v-model="formData.newPassword"
                  size="medium"
                  show-password
                  @keyup.enter="submitForm"
                />
              </material-input>
            </el-form-item>

            <el-form-item prop="confirmPassword">
              <material-input :label="$sakura.locale.changePassword.confirm_password" size="medium">
                <el-input
                  v-model="formData.confirmPassword"
                  size="medium"
                  show-password
                  @keyup.enter="submitForm"
                />
              </material-input>
            </el-form-item>

            <el-form-item class="center" id="change_password_button">
              <el-button @click="back">{{ $sakura.locale.opt.cancel }}</el-button>
              <el-button type="primary" @click="submitForm">{{ $sakura.locale.opt.save }}</el-button>
            </el-form-item>
          </el-form>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script setup>
import { ref, reactive, getCurrentInstance } from 'vue'
import { useRouter } from 'vue-router'
import { useAuthStore } from '@/stores';

const router = useRouter()
const authStore = useAuthStore()
const $sakura = getCurrentInstance()?.appContext.config.globalProperties.$sakura;

const ruleForm = ref(null)

const formData = reactive({
  newPassword: '',
  confirmPassword: ''
})

const confirmPasswordError = $sakura.locale.verify.confirmPassword

const checkPassword = (rule, value, callback) => {
  if (value !== formData.newPassword) {
    callback(new Error(confirmPasswordError))
  } else {
    callback()
  }
}

const rules = {
  newPassword: [
    {
      required: true,
      message: $sakura.verifyRequired($sakura.locale.changePassword.new_password),
      trigger: 'change'
    },
    {
      ...$sakura.rules.password,
      message: $sakura.locale.rules.passwordSpecial
    }
  ],
  confirmPassword: [
    {
      required: true,
      message: $sakura.verifyRequired($sakura.locale.changePassword.confirm_password),
      trigger: 'change'
    },
    {
      validator: checkPassword,
      trigger: 'change'
    }
  ]
}

const submitForm = () => {
  ruleForm.value.validate(valid => {
    if (valid) {
      saveHandler()
    }
  })
}

const saveHandler = () => {
  const obj = $sakura.deepCopy(formData)
    authStore.changePassword({user: {
        name: 'admin',
        password: obj.newPassword
      }}).then(json => {
        if (json.resp.respCode === 0) {
            router.push({ path: '/login' })
        } else {
            $sakura.sakuraMessage(json.resp.respCode)
        }
      });
}

const back = () => {
  router.push({ path: '/login' })
}
</script>

<style scoped>
.change-password-container {
  height: 100%;
  align-items: center;
  background-color: #fff;
}

.box-card {
  width: 480px;
  margin: 0 auto;
}

.mb40 {
  margin-bottom: 40px;
}
</style>
